import ReactOnRails from 'react-on-rails';
import KeenformEditor from '../bundles/KeenformEditor/KeenformEditor';
import FormAttributeFormEditor from '../bundles/FormAttributeFormEditor/FormAttributeFormEditor';
import KeenformPostSubmitEditor from '../bundles/KeenformPostSubmitEditor/KeenformPostSubmitEditor';
import FormRuleEditor from '../bundles/FormRuleEditor/FormRuleEditor';
import FormRuleHelper from '../bundles/FormRuleEditor/FormRuleHelper';
import PublishKeenformCardComponent from '../bundles/PublishKeenformCard/PublishKeenformCardComponent';
import PlanSelectorComponent from '../bundles/PlanSelector/PlanSelector';
import MetadataTypeEditor from '../bundles/MetadataTypeEditor/MetadataTypeEditor';
import FormRulesView from '../bundles/FormRulesView/FormRulesView';

ReactOnRails.register({
  KeenformEditor,
  FormAttributeFormEditor,
  KeenformPostSubmitEditor,
  FormRuleEditor,
  FormRuleHelper,
  PublishKeenformCardComponent,
  PlanSelectorComponent,
  MetadataTypeEditor,
  FormRulesView
});
